import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useToast } from '../contexts/ToastContext';
import { useNavigate } from 'react-router-dom';

export default function Signup() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const { signup } = useAuth();
  const { addToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      addToast('Passwords do not match', 'error');
      return;
    }
    try {
      await signup(email, password);
      addToast('Account created successfully!', 'success');
      navigate('/');
    } catch (err) {
      setError(err.message);
      addToast(err.message || 'Signup failed', 'error');
    }
  };

  return (
    <section className="auth-panel">
      <h2>Sign Up</h2>
      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}
      <form onSubmit={handleSubmit}>
        <div className="row">
          <label>
            <div className="label-text">Email</div>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required />
          </label>
          <label>
            <div className="label-text">Password</div>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} required />
          </label>
          <label>
            <div className="label-text">Confirm Password</div>
            <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required />
          </label>
        </div>
        <button className="btn" type="submit">Sign Up</button>
      </form>
      <p>Already have an account? <a href="/login">Login</a></p>
    </section>
  );
}